import Vue from 'vue'

var message = {
  'MSG000999': 'エラーが発生しました。',
  'MSG000001': '{0}を入力してください。',
  'MSG000002': '{0}は{1}文字以内で入力してください。',
  'MSG000003': '{0}を{1}で入力してください。',
  'MSG000004': '{0}を選択してください。',
  'MSG000005': '{0}を正しく選択してください。',
  'MSG000006': '{0}を正しく入力してください。'
}

Vue.use({
  install (Vue, options) {
    Vue.prototype['$message'] = message
  }
})

export default message
